import axios from 'axios';

import settings from '@/data/constants';

import type { ConsultationStatusResponse } from './Consultation.types';

export const getConsultationStatus = async (
  consultationId: number | undefined,
  ffEnableSpotConsultationCancel: boolean
): Promise<ConsultationStatusResponse[]> => {
  let url = `${settings.url}/dropdown/consultation-status`;

  if (ffEnableSpotConsultationCancel && consultationId) {
    url = `${url}?consultationId=${consultationId}`;
  }

  const response = await axios.get<ConsultationStatusResponse[]>(url);

  return response?.data;
};
